module.exports = __webpack_public_path__ + "img/gotoo.c89c909f.png";